// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.parent-container {
  margin-top: 30px;
  padding: 10px;
  background-color: #ffffff;
  width: 100%;
  transition: all 0.3s ease;
}

.parent-container.expanded {
  padding-bottom: 20px;
}

/* Title and Button Styles */
.title-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.issue-title {
  color: #565656;
  font-size: 28px;
  font-weight: 700;
  margin-right: 20px; /* Add some space between title and buttons */
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.minimalist-button {
  background-color: transparent;
  border: 1px solid;
  padding: 5px 10px;
  border-radius: 15px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.minimalist-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.minimalist-button.active {
  background-color: rgba(0, 0, 0, 0.1);
}

.minimalist-button.stats { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }
.minimalist-button.definition { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }
.minimalist-button.bills { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }
.minimalist-button.subtopics { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }

.button-caret {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid currentColor;
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.button-caret.expanded {
  transform: rotate(180deg);
}

/* Issue Bar Styles */
.issue-bar-container {
  margin: 0;
  border-radius: 50px;
  background-color: white;
  min-height: 130px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Center content vertically */
  position: relative;
  transition: all 0.3s ease;
  z-index: 1;
  padding: 20px 0;
}

.parent-container.expanded .issue-bar-container {
  justify-content: flex-start; /* Align to top when expanded */
}

.issue-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

.issue-track {
  position: relative;
  max-width: 1127px;
  width: 95%;
  height: 20px;
  background: linear-gradient(to right, #4285f4, #f06a6a);
  border-radius: 10px;
  margin: 10px 20px;
  overflow: visible;
  flex-shrink: 0;
}

.issue-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%) scale(1.2);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border: 3px solid;
  border-radius: 50%;
  background-color: #458bea;
  overflow: hidden;
  box-shadow: 0 0 10px var(--glow-color);
  cursor: pointer;
  z-index: 100;
}

.issue-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.issue-labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 18px;
  color: #666;
  margin-top: 15px;
  font-weight: 400;
  line-height: 150%;
  z-index: 1;
  height: 10px;
}

/* Tooltip Styles */
.tooltip {
  visibility: hidden;
  width: 80px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.issue-thumb:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

/* Expanded Section Styles */
.expanded-section {
  width: 94%;
  background-color: rgba(255, 255, 255, 0);
  position: relative;
  margin-top: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-height: 1900px;
  padding-bottom: 50px;
}

.vertical-line {
  position: absolute;
  top: 0;
  bottom: -80px;
  width: 2px;
  border-left: 2px solid;
  z-index: 10;
  transition: 0.3s ease;
}

.vertical-line-label {
  position: absolute;
  top: 100%;
  left: -12.5px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: white;
  text-align: center;
  line-height: 30px;
  z-index: 10;
  transition: 0.3s ease;
}

.legend-and-slider-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 0 10px;
}

.year-slider-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.year-slider-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0;
  opacity: 0.7;
}

.year-slider {
  margin: 0 10px;
}

.year-label {
  font-size: 12px !important;
  color: #666;
  white-space: nowrap;
  margin-bottom: 5px;
  opacity: 0.8;
}

.year-slider {
  flex: 1 1;
  min-width: 200px;
}

.gray-disclaimer {
  font-size: 12px;
  color: #999;
  text-align: right;
  width: 100%;
  margin-bottom: 5px;
}

/* Definition Section Styles */
.expanded-section.definition-section {
  padding: 10px;
  text-align: left;
  height: auto;
  min-height: 150px;
  overflow-y: auto;
}

.expanded-section.definition-section h3 {
  margin-bottom: 8px;
  color: #333;
  font-size: 16px;
}

.expanded-section.definition-section p {
  margin-bottom: 12px;
  color: #666;
  font-size: 12px;
  line-height: 1.4;
}

.definition-labels {
  display: flex;
  justify-content: space-between;
}

.definition-label {
  width: 48%;
}

.definition-label h4 {
  margin-bottom: 4px;
  color: #333;
  font-size: 14px;
}

.definition-label p {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

/* Subtopics Section Styles */
.expanded-section.subtopics-section {
  padding: 10px;
  text-align: left;
}

.subtopics-bubbles {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.subtopic-bubble {
  background-color: #f0f0f0;
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 12px;
  color: #333;
}

/* Bills Section Styles */
.expanded-section.bills-section {
  padding: 20px;
  text-align: left;
  max-height: 600px; /* Adjust this value as needed */
  overflow-y: auto;
}

.bills-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.bill-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.bill-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.bill-card .bill-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.bill-card h4 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.bill-card .bill-result {
  font-size: 14px;
  font-weight: 600;
  color: #4285f4;
  background-color: rgba(66, 133, 244, 0.1);
  padding: 4px 8px;
  border-radius: 12px;
}

.bill-card .topic-name {
  font-style: italic;
  color: #666;
  margin-bottom: 12px;
  font-size: 14px;
}

.bill-card .title-wrapper {
  margin-bottom: 12px;
  max-height: 60px; /* Reduced from 80px */
  overflow: hidden;
}

.bill-card .title-wrapper .title {
  font-weight: 600;
  font-size: 16px; /* Reduced from 20px */
  line-height: 1.3;
  color: #2c3e50;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bill-card .summary {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  line-height: 1.5;
  position: relative;
}

.bill-card .summary:not(.expanded) {
  max-height: 80px;
  overflow: hidden;
}

.bill-card .summary.expanded {
  max-height: none;
}

.bill-card .summary:not(.expanded)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  background: linear-gradient(transparent, #ffffff);
}

.bill-card .show-more-btn {
  background: none;
  border: none;
  color: #4285f4;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  margin-bottom: 16px;
  text-decoration: underline;
  display: block;
}

.bill-card .show-more-btn:hover {
  color: #2a75f3;
}

.bill-card .action-info {
  font-size: 12px;
  color: #777;
  margin-bottom: 16px;
  background-color: #f8f9fa;
  padding: 8px 12px;
  border-radius: 8px;
}

.bill-card .stats-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bill-card .vote-chart {
  width: 150px;
  height: 150px;
}

.bill-card .percentile {
  width: calc(100% - 170px);
  text-align: center;
}

.bill-card .percentile-bar {
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: visible;
  margin-bottom: 8px;
  position: relative;
}

.bill-card .percentile-marker {
  position: absolute;
  top: -6px;
  width: 4px;
  height: 20px;
  background-color: #3498db;
  border-radius: 2px;
}

.bill-card .liberal,
.bill-card .conservative {
  font-size: 12px;
  color: #666;
  font-weight: 600;
}

.bill-card .liberal {
  float: left;
}

.bill-card .conservative {
  float: right;
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .bill-card {
    padding: 20px;
  }

  .bill-card .stats-container {
    flex-direction: column;
  }

  .bill-card .vote-chart,
  .bill-card .percentile {
    width: 100%;
    margin-bottom: 20px;
  }
}

/* Media Queries */
@media (max-width: 1224px) {
  .issue-graph {
    position: relative;
    width: 100%;
    margin-top: 10px;
    z-index: 10;
    height: 50px;
    top: 10px;
  }

  .scores-container { width: 90%; }
  .parent-container.expanded .issue-bar-container {
    height: auto; /* Allow height to adjust to content */
  }
  .issue-bar-container {
    height: auto; /* Allow height to adjust to content */
    display: flex;
    align-items: center;
    justify-content: center; /* Keep centered on larger screens */
    position: relative;
  }
  .issue-bar { 
    position: relative;
    top: 0;
    height: auto !important; 
  }
  .issue-track { height: 6px; width: 95%; }
  .issue-labels { margin-top: 10px; font-size: 10px; }
  .issue-thumb {
    width: 30px;
    height: 30px;
    top: 50%;
    transform: translate(-50%, -50%) scale(1.0);
  }
  .expanded-section {
    width: 95%;
    top: -10px;
  }

  .title-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .button-group {
    margin-top: 10px;
    width: 100%;
    justify-content: flex-start;
    z-index: 100;
    position: relative;
  }
  .issue-title { margin-right: 0; }
  .parent-container.expanded .issue-bar-container {
    height: auto;
    min-height: auto; /* Remove fixed min-height */
  }
  .issue-bar-container { 
    height: 61px; 
    min-height: 60px;
    justify-content: center; /* Keep centered on mobile */
  }
  .issue-bar { 
    position: relative;
    top: 0; 
  }
  .issue-track { height: 8px; }
  .issue-labels { margin-top: 15px; font-size: 12px; }
  .issue-thumb { width: 36px; height: 36px; }
  .expanded-section {
  }
  .definition-section h3 { font-size: 18px; }
  .definition-section p { font-size: 14px; }
  .definition-label h4 { font-size: 16px; }
  .definition-label p { font-size: 14px; }
  .button-group { flex-wrap: wrap; }
  .minimalist-button {
    margin-bottom: 5px;
    padding: 8px 12px;
    font-size: 14px;
  }

  .subtopics-bubbles {
    justify-content: center;
  }

  .subtopic-bubble {
    font-size: 10px;
  }

  .expanded-section.bills-section {
    overflow-x: auto; /* Allow horizontal scrolling only in mobile view */
  }

  .bills-table {
    font-size: 12px;
    min-width: 300px; /* Ensure table has a minimum width */
  }

  .bills-table th,
  .bills-table td {
    padding: 5px;
    white-space: nowrap; /* Prevent text wrapping */
  }

  .bills-table th {
    position: sticky; /* Keep headers visible while scrolling */
    top: 0;
    z-index: 1;
  }
}

/* Graph Styles */
.issue-graph {


  width: 100%;
  height: 100px !important; /* Adjust this value to change the graph height */
  margin-top: -30px;
}

/* Loading Spinner Styles */
.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Update the media query for mobile devices */
@media (max-width: 768px) {
  .legend-and-slider-container {
    flex-direction: column;
    align-items: stretch;
  }

  .legend-label, .year-slider-container {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .year-slider-wrapper {
    flex-direction: column;
    align-items: stretch;
  }

  .year-label {
    margin-right: 0;
    margin-bottom: 10px;
    text-align: center;
  }

  .year-slider {
    width: 100%;
  }

  .year-slider-wrapper {
    padding: 5px 0;
  }
  
  .year-slider {
    margin: 0 5px;
  }
}

.issue-thumb.grayed-out {
  opacity: 0.5;
}

.callouts {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}

.callout {
  margin-bottom: 5px;
}

/* Update the media query for mobile devices */
@media (max-width: 768px) {
  /* ... (previous mobile styles) */

  .callouts {
    text-align: left;
    padding: 0 10px;
  }
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .expanded-section.bills-section {
    max-height: none; /* Remove max-height on mobile */
    overflow-y: visible; /* Remove scrolling on mobile */
  }

  /* ... (keep other existing mobile styles) */
}

/* Update the year slider styles */
.year-slider-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0;
  opacity: 0.7;
}

.year-label {
  font-size: 12px !important;
  color: #666;
  white-space: nowrap;
  margin-bottom: 5px;
  opacity: 0.8;
}

/* Override Material-UI slider styles */
.MuiSlider-root {
  color: #999 !important; /* More muted color */
}

.MuiSlider-rail {
  background-color: #e0e0e0 !important;
  opacity: 0.5 !important;
}

.MuiSlider-track {
  background-color: #999 !important;
  opacity: 0.7 !important;
}

.MuiSlider-thumb {
  background-color: #fff !important;
  border: 2px solid #999 !important;
  width: 16px !important;
  height: 16px !important;
  margin-top: -7px !important;
}

.MuiSlider-thumb:hover,
.MuiSlider-thumb.Mui-focusVisible {
  box-shadow: 0 0 0 8px rgba(153, 153, 153, 0.16) !important;
}

.MuiSlider-thumb.Mui-active {
  box-shadow: 0 0 0 12px rgba(153, 153, 153, 0.16) !important;
}

.MuiSlider-valueLabel {
  background-color: #999 !important;
  font-size: 11px !important;
}

/* Update media queries for mobile */
@media (max-width: 768px) {
  .year-slider-wrapper {
    padding: 5px 0;
  }
  
  .year-label {
    font-size: 11px !important;
  }

  .MuiSlider-thumb {
    width: 14px !important;
    height: 14px !important;
    margin-top: -6px !important;
  }
}

.politician-votes {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 20px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.politician-vote {
  display: flex;
  align-items: center;
  gap: 8px;
}

.politician-vote .rep-thumb {
  position: relative;
  transform: none;
  width: 32px;
  height: 32px;
  top: 0;
  left: 0;
}

.politician-vote .vote-type {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
}

.politician-vote .vote-type.yea,
.politician-vote .vote-type.aye {
  background-color: rgba(66, 133, 244, 0.1);
  color: #4285f4;
}

.politician-vote .vote-type.no,
.politician-vote .vote-type.nay {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.politician-vote .vote-type.not_voting {
  background-color: rgba(158, 158, 158, 0.1);
  color: #9e9e9e;
}

.bill-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.bill-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.bill-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.politician-votes {
    display: flex;
    gap: 12px;
    align-items: center;
}

.politician-vote .vote-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 20px;
    font-weight: 500;
}

.politician-photo {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
}

.vote-indicator.yea,
.vote-indicator.aye {
    background-color: rgba(66, 133, 244, 0.1);
    color: #4285f4;
}

.vote-indicator.no,
.vote-indicator.nay {
    background-color: rgba(244, 67, 54, 0.1);
    color: #f44336;
}

.vote-indicator.not_voting {
    background-color: rgba(158, 158, 158, 0.1);
    color: #9e9e9e;
}

.bill-content {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 24px;
}

.vote-summary {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.vote-stats {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.vote-stat {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #666;
}

@media (max-width: 768px) {
    .bill-content {
        grid-template-columns: 1fr;
    }
    
    .bill-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    
    .politician-votes {
        flex-wrap: wrap;
    }
}

.ideology-meter {
  margin: 20px 0;
  padding: 10px 0;
}

.percentile {
  width: 100%;
  text-align: center;
}

.percentile-bar {
  height: 8px;
  background: linear-gradient(to right, #4285f4, #f06a6a);
  border-radius: 4px;
  position: relative;
  margin-bottom: 8px;
}

.percentile-marker {
  position: absolute;
  top: -6px;
  width: 4px;
  height: 20px;
  background-color: #000;
  border-radius: 2px;
  transform: translateX(-50%);
  transition: left 0.3s ease;
}

.percentile-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.liberal {
  color: #4285f4;
}

.conservative {
  color: #f06a6a;
}

/* Update the vote summary layout */
.vote-summary {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
}

.vote-chart {
  height: 200px;
  position: relative;
}

.vote-totals {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.vote-totals h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 16px;
}

.vote-breakdown {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vote-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
}

.vote-stat.yes {
  background-color: rgba(66, 133, 244, 0.1);
  color: #4285f4;
}

.vote-stat.no {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.vote-stat.not-voting {
  background-color: rgba(158, 158, 158, 0.1);
  color: #9e9e9e;
}

/* Add these new styles */
.vote-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.vote-container h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.vote-container .vote-totals {
  background: #f8f9fa;
  margin-bottom: 15px;
}

.vote-container .vote-chart {
  height: 150px;
  margin-bottom: 15px;
}

.vote-container .politician-votes {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* Update existing styles */
.bill-content {
  display: grid;
  grid-template-columns: 1fr 350px; /* Increased width for vote summary */
  gap: 24px;
}

@media (max-width: 768px) {
  .vote-container {
    padding: 15px;
  }

  .vote-container .vote-chart {
    height: 120px;
  }
}

/* Replace the vote-totals and vote-chart styles with these new styles */

.vote-container {
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.vote-container h4 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.vote-bars {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vote-bar-container {
  width: 100%;
}

.vote-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 14px;
  color: #666;
}

.vote-bar-wrapper {
  width: 100%;
  height: 12px;
  background-color: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}

.vote-bar {
  height: 100%;
  transition: width 0.3s ease;
}

.vote-bar.yes {
  background-color: #4285f4;
  background-image: linear-gradient(45deg, 
    rgba(255,255,255,0.15) 25%, 
    transparent 25%, 
    transparent 50%, 
    rgba(255,255,255,0.15) 50%, 
    rgba(255,255,255,0.15) 75%, 
    transparent 75%, 
    transparent
  );
  background-size: 20px 20px;
}

.vote-bar.no {
  background-color: #f44336;
  background-image: linear-gradient(45deg,
    rgba(255,255,255,0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255,255,255,0.15) 50%,
    rgba(255,255,255,0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
}

.vote-bar.not-voting {
  background-color: #9e9e9e;
  background-image: linear-gradient(45deg,
    rgba(255,255,255,0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255,255,255,0.15) 50%,
    rgba(255,255,255,0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
}

.politician-votes {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

/* Update media queries */
@media (max-width: 768px) {
  .vote-container {
    padding: 16px;
  }

  .vote-label {
    font-size: 12px;
  }

  .vote-bar-wrapper {
    height: 10px;
  }
}

.legend-label {
  flex: 1 1;
  font-size: 14px;
  color: #666;
  padding: 10px 0;
}

.legend-label .users {
  color: #9e9e9e;  /* Changed to gray to match the graph */
}

.legend-label .republicans {
  color: #f06a6a;
}

.legend-label .democrats {
  color: #4285f4;
}
`, "",{"version":3,"sources":["webpack://./src/components/IssueBar/style.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,2BAA2B,8BAA8B,EAAE,qCAAqC,EAAE;AAClG,gCAAgC,8BAA8B,EAAE,qCAAqC,EAAE;AACvG,2BAA2B,8BAA8B,EAAE,qCAAqC,EAAE;AAClG,+BAA+B,8BAA8B,EAAE,qCAAqC,EAAE;;AAEtG;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAE,8BAA8B;EACvD,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,+BAA+B;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,uDAAuD;EACvD,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe,EAAE,sBAAsB;EACvC,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA,oBAAoB,UAAU,EAAE;EAChC;IACE,YAAY,EAAE,sCAAsC;EACtD;EACA;IACE,YAAY,EAAE,sCAAsC;IACpD,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAE,oCAAoC;IAC7D,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,uBAAuB;EACzB;EACA,eAAe,WAAW,EAAE,UAAU,EAAE;EACxC,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;EACnD;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;EACpB;EACA,eAAe,eAAe,EAAE;EAChC;IACE,YAAY;IACZ,gBAAgB,EAAE,4BAA4B;EAChD;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB,EAAE,4BAA4B;EACvD;EACA;IACE,kBAAkB;IAClB,MAAM;EACR;EACA,eAAe,WAAW,EAAE;EAC5B,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;EACnD,eAAe,WAAW,EAAE,YAAY,EAAE;EAC1C;EACA;EACA,yBAAyB,eAAe,EAAE;EAC1C,wBAAwB,eAAe,EAAE;EACzC,uBAAuB,eAAe,EAAE;EACxC,sBAAsB,eAAe,EAAE;EACvC,gBAAgB,eAAe,EAAE;EACjC;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB,EAAE,mDAAmD;EACvE;;EAEA;IACE,eAAe;IACf,gBAAgB,EAAE,qCAAqC;EACzD;;EAEA;;IAEE,YAAY;IACZ,mBAAmB,EAAE,0BAA0B;EACjD;;EAEA;IACE,gBAAgB,EAAE,yCAAyC;IAC3D,MAAM;IACN,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;;;EAGE,WAAW;EACX,wBAAwB,EAAE,iDAAiD;EAC3E,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,8CAA8C;AAC9C;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,iCAAiC;;EAEjC;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB,EAAE,gCAAgC;IAClD,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,sBAAsB,EAAE,qBAAqB;AAC/C;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uDAAuD;EACvD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gCAAgC,EAAE,qCAAqC;EACvE,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wEAAwE;;AAExE;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB;;;;;;;;GAQC;EACD,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB;;;;;;;;GAQC;EACD,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB;;;;;;;;GAQC;EACD,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc,GAAG,uCAAuC;AAC1D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* General Styles */\n.parent-container {\n  margin-top: 30px;\n  padding: 10px;\n  background-color: #ffffff;\n  width: 100%;\n  transition: all 0.3s ease;\n}\n\n.parent-container.expanded {\n  padding-bottom: 20px;\n}\n\n/* Title and Button Styles */\n.title-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n}\n\n.issue-title {\n  color: #565656;\n  font-size: 28px;\n  font-weight: 700;\n  margin-right: 20px; /* Add some space between title and buttons */\n}\n\n.button-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.minimalist-button {\n  background-color: transparent;\n  border: 1px solid;\n  padding: 5px 10px;\n  border-radius: 15px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.minimalist-button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.minimalist-button.active {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.minimalist-button.stats { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }\n.minimalist-button.definition { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }\n.minimalist-button.bills { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }\n.minimalist-button.subtopics { color: rgba(66, 133, 244, 0.5); border-color: rgba(66, 133, 244, 0.5); }\n\n.button-caret {\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid currentColor;\n  margin-left: 5px;\n  transition: transform 0.3s ease;\n}\n\n.button-caret.expanded {\n  transform: rotate(180deg);\n}\n\n/* Issue Bar Styles */\n.issue-bar-container {\n  margin: 0;\n  border-radius: 50px;\n  background-color: white;\n  min-height: 130px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; /* Center content vertically */\n  position: relative;\n  transition: all 0.3s ease;\n  z-index: 1;\n  padding: 20px 0;\n}\n\n.parent-container.expanded .issue-bar-container {\n  justify-content: flex-start; /* Align to top when expanded */\n}\n\n.issue-bar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  position: relative;\n}\n\n.issue-track {\n  position: relative;\n  max-width: 1127px;\n  width: 95%;\n  height: 20px;\n  background: linear-gradient(to right, #4285f4, #f06a6a);\n  border-radius: 10px;\n  margin: 10px 20px;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.issue-thumb {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%) scale(1.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  border: 3px solid;\n  border-radius: 50%;\n  background-color: #458bea;\n  overflow: hidden;\n  box-shadow: 0 0 10px var(--glow-color);\n  cursor: pointer;\n  z-index: 100;\n}\n\n.issue-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.issue-labels {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 18px;\n  color: #666;\n  margin-top: 15px;\n  font-weight: 400;\n  line-height: 150%;\n  z-index: 1;\n  height: 10px;\n}\n\n/* Tooltip Styles */\n.tooltip {\n  visibility: hidden;\n  width: 80px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.issue-thumb:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: black transparent transparent transparent;\n}\n\n/* Expanded Section Styles */\n.expanded-section {\n  width: 94%;\n  background-color: rgba(255, 255, 255, 0);\n  position: relative;\n  margin-top: 20px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  max-height: 1900px;\n  padding-bottom: 50px;\n}\n\n.vertical-line {\n  position: absolute;\n  top: 0;\n  bottom: -80px;\n  width: 2px;\n  border-left: 2px solid;\n  z-index: 10;\n  transition: 0.3s ease;\n}\n\n.vertical-line-label {\n  position: absolute;\n  top: 100%;\n  left: -12.5px;\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  color: white;\n  text-align: center;\n  line-height: 30px;\n  z-index: 10;\n  transition: 0.3s ease;\n}\n\n.legend-and-slider-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  padding: 0 10px;\n}\n\n.year-slider-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.year-slider-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px 0;\n  opacity: 0.7;\n}\n\n.year-slider {\n  margin: 0 10px;\n}\n\n.year-label {\n  font-size: 12px !important;\n  color: #666;\n  white-space: nowrap;\n  margin-bottom: 5px;\n  opacity: 0.8;\n}\n\n.year-slider {\n  flex: 1;\n  min-width: 200px;\n}\n\n.gray-disclaimer {\n  font-size: 12px;\n  color: #999;\n  text-align: right;\n  width: 100%;\n  margin-bottom: 5px;\n}\n\n/* Definition Section Styles */\n.expanded-section.definition-section {\n  padding: 10px;\n  text-align: left;\n  height: auto;\n  min-height: 150px;\n  overflow-y: auto;\n}\n\n.expanded-section.definition-section h3 {\n  margin-bottom: 8px;\n  color: #333;\n  font-size: 16px;\n}\n\n.expanded-section.definition-section p {\n  margin-bottom: 12px;\n  color: #666;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.definition-labels {\n  display: flex;\n  justify-content: space-between;\n}\n\n.definition-label {\n  width: 48%;\n}\n\n.definition-label h4 {\n  margin-bottom: 4px;\n  color: #333;\n  font-size: 14px;\n}\n\n.definition-label p {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.3;\n}\n\n/* Subtopics Section Styles */\n.expanded-section.subtopics-section {\n  padding: 10px;\n  text-align: left;\n}\n\n.subtopics-bubbles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.subtopic-bubble {\n  background-color: #f0f0f0;\n  border-radius: 20px;\n  padding: 5px 10px;\n  font-size: 12px;\n  color: #333;\n}\n\n/* Bills Section Styles */\n.expanded-section.bills-section {\n  padding: 20px;\n  text-align: left;\n  max-height: 600px; /* Adjust this value as needed */\n  overflow-y: auto;\n}\n\n.bills-list {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n}\n\n.bill-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.bill-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.bill-card .bill-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.bill-card h4 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.bill-card .bill-result {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4285f4;\n  background-color: rgba(66, 133, 244, 0.1);\n  padding: 4px 8px;\n  border-radius: 12px;\n}\n\n.bill-card .topic-name {\n  font-style: italic;\n  color: #666;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.bill-card .title-wrapper {\n  margin-bottom: 12px;\n  max-height: 60px; /* Reduced from 80px */\n  overflow: hidden;\n}\n\n.bill-card .title-wrapper .title {\n  font-weight: 600;\n  font-size: 16px; /* Reduced from 20px */\n  line-height: 1.3;\n  color: #2c3e50;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* Limit to 2 lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bill-card .summary {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 8px;\n  line-height: 1.5;\n  position: relative;\n}\n\n.bill-card .summary:not(.expanded) {\n  max-height: 80px;\n  overflow: hidden;\n}\n\n.bill-card .summary.expanded {\n  max-height: none;\n}\n\n.bill-card .summary:not(.expanded)::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 20px;\n  background: linear-gradient(transparent, #ffffff);\n}\n\n.bill-card .show-more-btn {\n  background: none;\n  border: none;\n  color: #4285f4;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0;\n  margin-bottom: 16px;\n  text-decoration: underline;\n  display: block;\n}\n\n.bill-card .show-more-btn:hover {\n  color: #2a75f3;\n}\n\n.bill-card .action-info {\n  font-size: 12px;\n  color: #777;\n  margin-bottom: 16px;\n  background-color: #f8f9fa;\n  padding: 8px 12px;\n  border-radius: 8px;\n}\n\n.bill-card .stats-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bill-card .vote-chart {\n  width: 150px;\n  height: 150px;\n}\n\n.bill-card .percentile {\n  width: calc(100% - 170px);\n  text-align: center;\n}\n\n.bill-card .percentile-bar {\n  height: 8px;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  overflow: visible;\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.bill-card .percentile-marker {\n  position: absolute;\n  top: -6px;\n  width: 4px;\n  height: 20px;\n  background-color: #3498db;\n  border-radius: 2px;\n}\n\n.bill-card .liberal,\n.bill-card .conservative {\n  font-size: 12px;\n  color: #666;\n  font-weight: 600;\n}\n\n.bill-card .liberal {\n  float: left;\n}\n\n.bill-card .conservative {\n  float: right;\n}\n\n/* Responsive design for mobile */\n@media (max-width: 768px) {\n  .bill-card {\n    padding: 20px;\n  }\n\n  .bill-card .stats-container {\n    flex-direction: column;\n  }\n\n  .bill-card .vote-chart,\n  .bill-card .percentile {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n}\n\n/* Media Queries */\n@media (max-width: 1224px) {\n  .issue-graph {\n    position: relative;\n    width: 100%;\n    margin-top: 10px;\n    z-index: 10;\n    height: 50px;\n    top: 10px;\n  }\n\n  .scores-container { width: 90%; }\n  .parent-container.expanded .issue-bar-container {\n    height: auto; /* Allow height to adjust to content */\n  }\n  .issue-bar-container {\n    height: auto; /* Allow height to adjust to content */\n    display: flex;\n    align-items: center;\n    justify-content: center; /* Keep centered on larger screens */\n    position: relative;\n  }\n  .issue-bar { \n    position: relative;\n    top: 0;\n    height: auto !important; \n  }\n  .issue-track { height: 6px; width: 95%; }\n  .issue-labels { margin-top: 10px; font-size: 10px; }\n  .issue-thumb {\n    width: 30px;\n    height: 30px;\n    top: 50%;\n    transform: translate(-50%, -50%) scale(1.0);\n  }\n  .expanded-section {\n    width: 95%;\n    top: -10px;\n  }\n\n  .title-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .button-group {\n    margin-top: 10px;\n    width: 100%;\n    justify-content: flex-start;\n    z-index: 100;\n    position: relative;\n  }\n  .issue-title { margin-right: 0; }\n  .parent-container.expanded .issue-bar-container {\n    height: auto;\n    min-height: auto; /* Remove fixed min-height */\n  }\n  .issue-bar-container { \n    height: 61px; \n    min-height: 60px;\n    justify-content: center; /* Keep centered on mobile */\n  }\n  .issue-bar { \n    position: relative;\n    top: 0; \n  }\n  .issue-track { height: 8px; }\n  .issue-labels { margin-top: 15px; font-size: 12px; }\n  .issue-thumb { width: 36px; height: 36px; }\n  .expanded-section {\n  }\n  .definition-section h3 { font-size: 18px; }\n  .definition-section p { font-size: 14px; }\n  .definition-label h4 { font-size: 16px; }\n  .definition-label p { font-size: 14px; }\n  .button-group { flex-wrap: wrap; }\n  .minimalist-button {\n    margin-bottom: 5px;\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n\n  .subtopics-bubbles {\n    justify-content: center;\n  }\n\n  .subtopic-bubble {\n    font-size: 10px;\n  }\n\n  .expanded-section.bills-section {\n    overflow-x: auto; /* Allow horizontal scrolling only in mobile view */\n  }\n\n  .bills-table {\n    font-size: 12px;\n    min-width: 300px; /* Ensure table has a minimum width */\n  }\n\n  .bills-table th,\n  .bills-table td {\n    padding: 5px;\n    white-space: nowrap; /* Prevent text wrapping */\n  }\n\n  .bills-table th {\n    position: sticky; /* Keep headers visible while scrolling */\n    top: 0;\n    z-index: 1;\n  }\n}\n\n/* Graph Styles */\n.issue-graph {\n\n\n  width: 100%;\n  height: 100px !important; /* Adjust this value to change the graph height */\n  margin-top: -30px;\n}\n\n/* Loading Spinner Styles */\n.loading-spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 20px auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Update the media query for mobile devices */\n@media (max-width: 768px) {\n  .legend-and-slider-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .legend-label, .year-slider-container {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 10px;\n  }\n\n  .year-slider-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .year-label {\n    margin-right: 0;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .year-slider {\n    width: 100%;\n  }\n\n  .year-slider-wrapper {\n    padding: 5px 0;\n  }\n  \n  .year-slider {\n    margin: 0 5px;\n  }\n}\n\n.issue-thumb.grayed-out {\n  opacity: 0.5;\n}\n\n.callouts {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #666;\n}\n\n.callout {\n  margin-bottom: 5px;\n}\n\n/* Update the media query for mobile devices */\n@media (max-width: 768px) {\n  /* ... (previous mobile styles) */\n\n  .callouts {\n    text-align: left;\n    padding: 0 10px;\n  }\n}\n\n/* Responsive design for mobile */\n@media (max-width: 768px) {\n  .expanded-section.bills-section {\n    max-height: none; /* Remove max-height on mobile */\n    overflow-y: visible; /* Remove scrolling on mobile */\n  }\n\n  /* ... (keep other existing mobile styles) */\n}\n\n/* Update the year slider styles */\n.year-slider-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 10px 0;\n  opacity: 0.7;\n}\n\n.year-label {\n  font-size: 12px !important;\n  color: #666;\n  white-space: nowrap;\n  margin-bottom: 5px;\n  opacity: 0.8;\n}\n\n/* Override Material-UI slider styles */\n.MuiSlider-root {\n  color: #999 !important; /* More muted color */\n}\n\n.MuiSlider-rail {\n  background-color: #e0e0e0 !important;\n  opacity: 0.5 !important;\n}\n\n.MuiSlider-track {\n  background-color: #999 !important;\n  opacity: 0.7 !important;\n}\n\n.MuiSlider-thumb {\n  background-color: #fff !important;\n  border: 2px solid #999 !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin-top: -7px !important;\n}\n\n.MuiSlider-thumb:hover,\n.MuiSlider-thumb.Mui-focusVisible {\n  box-shadow: 0 0 0 8px rgba(153, 153, 153, 0.16) !important;\n}\n\n.MuiSlider-thumb.Mui-active {\n  box-shadow: 0 0 0 12px rgba(153, 153, 153, 0.16) !important;\n}\n\n.MuiSlider-valueLabel {\n  background-color: #999 !important;\n  font-size: 11px !important;\n}\n\n/* Update media queries for mobile */\n@media (max-width: 768px) {\n  .year-slider-wrapper {\n    padding: 5px 0;\n  }\n  \n  .year-label {\n    font-size: 11px !important;\n  }\n\n  .MuiSlider-thumb {\n    width: 14px !important;\n    height: 14px !important;\n    margin-top: -6px !important;\n  }\n}\n\n.politician-votes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 20px;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n}\n\n.politician-vote {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.politician-vote .rep-thumb {\n  position: relative;\n  transform: none;\n  width: 32px;\n  height: 32px;\n  top: 0;\n  left: 0;\n}\n\n.politician-vote .vote-type {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.politician-vote .vote-type.yea,\n.politician-vote .vote-type.aye {\n  background-color: rgba(66, 133, 244, 0.1);\n  color: #4285f4;\n}\n\n.politician-vote .vote-type.no,\n.politician-vote .vote-type.nay {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n.politician-vote .vote-type.not_voting {\n  background-color: rgba(158, 158, 158, 0.1);\n  color: #9e9e9e;\n}\n\n.bill-card {\n    background-color: #ffffff;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n}\n\n.bill-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.bill-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.politician-votes {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.politician-vote .vote-indicator {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-weight: 500;\n}\n\n.politician-photo {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.vote-indicator.yea,\n.vote-indicator.aye {\n    background-color: rgba(66, 133, 244, 0.1);\n    color: #4285f4;\n}\n\n.vote-indicator.no,\n.vote-indicator.nay {\n    background-color: rgba(244, 67, 54, 0.1);\n    color: #f44336;\n}\n\n.vote-indicator.not_voting {\n    background-color: rgba(158, 158, 158, 0.1);\n    color: #9e9e9e;\n}\n\n.bill-content {\n    display: grid;\n    grid-template-columns: 1fr 300px;\n    gap: 24px;\n}\n\n.vote-summary {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.vote-stats {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.vote-stat {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    color: #666;\n}\n\n@media (max-width: 768px) {\n    .bill-content {\n        grid-template-columns: 1fr;\n    }\n    \n    .bill-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n    \n    .politician-votes {\n        flex-wrap: wrap;\n    }\n}\n\n.ideology-meter {\n  margin: 20px 0;\n  padding: 10px 0;\n}\n\n.percentile {\n  width: 100%;\n  text-align: center;\n}\n\n.percentile-bar {\n  height: 8px;\n  background: linear-gradient(to right, #4285f4, #f06a6a);\n  border-radius: 4px;\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.percentile-marker {\n  position: absolute;\n  top: -6px;\n  width: 4px;\n  height: 20px;\n  background-color: #000;\n  border-radius: 2px;\n  transform: translateX(-50%);\n  transition: left 0.3s ease;\n}\n\n.percentile-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.liberal {\n  color: #4285f4;\n}\n\n.conservative {\n  color: #f06a6a;\n}\n\n/* Update the vote summary layout */\n.vote-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.vote-chart {\n  height: 200px;\n  position: relative;\n}\n\n.vote-totals {\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.vote-totals h4 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.vote-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vote-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.vote-stat.yes {\n  background-color: rgba(66, 133, 244, 0.1);\n  color: #4285f4;\n}\n\n.vote-stat.no {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n.vote-stat.not-voting {\n  background-color: rgba(158, 158, 158, 0.1);\n  color: #9e9e9e;\n}\n\n/* Add these new styles */\n.vote-container {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.vote-container h4 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.vote-container .vote-totals {\n  background: #f8f9fa;\n  margin-bottom: 15px;\n}\n\n.vote-container .vote-chart {\n  height: 150px;\n  margin-bottom: 15px;\n}\n\n.vote-container .politician-votes {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* Update existing styles */\n.bill-content {\n  display: grid;\n  grid-template-columns: 1fr 350px; /* Increased width for vote summary */\n  gap: 24px;\n}\n\n@media (max-width: 768px) {\n  .vote-container {\n    padding: 15px;\n  }\n\n  .vote-container .vote-chart {\n    height: 120px;\n  }\n}\n\n/* Replace the vote-totals and vote-chart styles with these new styles */\n\n.vote-container {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n.vote-container h4 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.vote-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.vote-bar-container {\n  width: 100%;\n}\n\n.vote-label {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n  font-size: 14px;\n  color: #666;\n}\n\n.vote-bar-wrapper {\n  width: 100%;\n  height: 12px;\n  background-color: #f0f0f0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.vote-bar {\n  height: 100%;\n  transition: width 0.3s ease;\n}\n\n.vote-bar.yes {\n  background-color: #4285f4;\n  background-image: linear-gradient(45deg, \n    rgba(255,255,255,0.15) 25%, \n    transparent 25%, \n    transparent 50%, \n    rgba(255,255,255,0.15) 50%, \n    rgba(255,255,255,0.15) 75%, \n    transparent 75%, \n    transparent\n  );\n  background-size: 20px 20px;\n}\n\n.vote-bar.no {\n  background-color: #f44336;\n  background-image: linear-gradient(45deg,\n    rgba(255,255,255,0.15) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255,255,255,0.15) 50%,\n    rgba(255,255,255,0.15) 75%,\n    transparent 75%,\n    transparent\n  );\n  background-size: 20px 20px;\n}\n\n.vote-bar.not-voting {\n  background-color: #9e9e9e;\n  background-image: linear-gradient(45deg,\n    rgba(255,255,255,0.15) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255,255,255,0.15) 50%,\n    rgba(255,255,255,0.15) 75%,\n    transparent 75%,\n    transparent\n  );\n  background-size: 20px 20px;\n}\n\n.politician-votes {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n/* Update media queries */\n@media (max-width: 768px) {\n  .vote-container {\n    padding: 16px;\n  }\n\n  .vote-label {\n    font-size: 12px;\n  }\n\n  .vote-bar-wrapper {\n    height: 10px;\n  }\n}\n\n.legend-label {\n  flex: 1;\n  font-size: 14px;\n  color: #666;\n  padding: 10px 0;\n}\n\n.legend-label .users {\n  color: #9e9e9e;  /* Changed to gray to match the graph */\n}\n\n.legend-label .republicans {\n  color: #f06a6a;\n}\n\n.legend-label .democrats {\n  color: #4285f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
